import axiosClient from 'config/axios';
import tokenConfig from 'config/auth';

import {
  GET_EMPLOYEES, ADD_EMPLOYEE, UPDATE_EMPLOYEE, UPDATE_EMPLOYEE_EXP_SALARY
} from 'redux/actionTypes';
import { incrementIDGen } from '.';
import { employee } from 'variables/idGenType';

export const getEmployees = () => (dispatch, getState) => {
  axiosClient
    .get('/api/employees', tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_EMPLOYEES,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const addEmployee = (newEmployee, userId) => (dispatch, getState) => {
  axiosClient
    .post('/api/employees', newEmployee, tokenConfig(getState))
    .then(res => {
      dispatch(incrementIDGen({ id: userId, field: employee }));
      dispatch({
        type: ADD_EMPLOYEE,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const updateEmployee = (updatedEmployee) => (dispatch, getState) => {
  axiosClient
    .patch('/api/employees', updatedEmployee, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: UPDATE_EMPLOYEE,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const addEmployeeExpectedSalary = (salaryInfo) => (dispatch, getState) => {
  axiosClient
    .patch('/api/employees/expected', salaryInfo, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: UPDATE_EMPLOYEE_EXP_SALARY,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};